import React from 'react';
import './FooterSection.css';
import attLogo from './assets/AT&T Authorized Logo.png';
import directvLogo from './assets/directv_PreferredDealer_rgb_4cp_pos (1).png';
import frontierLogo from './assets/Frontier_AuthSalesAgent_Secondary_Small_RGB_Red (1).png';
import kineticLogo from './assets/KineticByWindstreamAuthAgentLogoHorz4c (1).png';
import optimumLogo from './assets/Opt_Auth_Reseller_Logo_Vert_POS_CMYK (2).png';
import riseLogo from './assets/Rise Broadband.png';
import spectrumLogo from './assets/spectrum.png';
import vivintLogo from './assets/Vivint Logo (1).png';

const FooterSection = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="clients-section">
          <h3 className="clients-title">Trusted By Industry Leaders</h3>
          <div className="clients-grid">
            <div className="client-logo">
              <img src={attLogo} alt="AT&T" />
            </div>
            <div className="client-logo">
              <img src={directvLogo} alt="DirecTV" />
            </div>
            <div className="client-logo">
              <img src={frontierLogo} alt="Frontier" />
            </div>
            <div className="client-logo">
              <img src={kineticLogo} alt="Kinetic by Windstream" />
            </div>
            <div className="client-logo">
              <img src={optimumLogo} alt="Optimum" />
            </div>
            <div className="client-logo">
              <img src={riseLogo} alt="Rise Broadband" />
            </div>
            <div className="client-logo">
              <img src={spectrumLogo} alt="Spectrum" />
            </div>
            <div className="client-logo">
              <img src={vivintLogo} alt="Vivint" />
            </div>
          </div>
        </div>

        <div className="footer-content">
          <div className="footer-column">
            <div className="footer-logo">
              <h3>IXL Marketing Solutions</h3>
              <p>Transforming businesses through innovative marketing strategies and cutting-edge solutions.</p>
            </div>
            <div className="social-links">
              <a href="#" aria-label="Facebook">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="#" aria-label="Twitter">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="#" aria-label="LinkedIn">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#" aria-label="Instagram">
                <i className="fab fa-instagram"></i>
              </a>
            </div>
          </div>
          
          <div className="footer-column">
            <h4>Services</h4>
            <ul>
              <li><a href="#">Digital Marketing</a></li>
              <li><a href="#">Brand Strategy</a></li>
              <li><a href="#">Customer Engagement</a></li>
              <li><a href="#">Content Marketing</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><a href="#">About Us</a></li>
              <li><a href="#">Our Team</a></li>
              <li><a href="#">Careers</a></li>
              <li><a href="#">Case Studies</a></li>
              <li><a href="#">Blog</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Contact</h4>
            <div className="contact-info">
              <p>
                <i className="fas fa-map-marker-alt"></i>
                123 Success Lane<br />
                Hometown, USA 12345
              </p>
              <p>
                <i className="fas fa-phone"></i>
                <a href="tel:+1234567890">(123) 456-7890</a>
              </p>
              <p>
                <i className="fas fa-envelope"></i>
                <a href="mailto:info@ixlmarketingsolutions.net">info@ixlmarketingsolutions.net</a>
              </p>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} IXL Marketing Solutions. All rights reserved.</p>
            <div className="footer-links">
              <a href="#">Privacy Policy</a>
              <a href="#">Terms of Service</a>
              <a href="#">Cookie Policy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
